import { api } from 'shared/api'

import { CartReplyApi } from './schemas'

export const cartReplyApi = {
  getData: api.account.createGet({
    url: '/cartReply/getData',
    schemas: CartReplyApi.getData,
    scope: 'whatsapp',
    section: 'cart_reply',
  }),
  switch: api.account.createPost({
    url: '/cartReply/switch',
    schemas: CartReplyApi.switch,
    scope: 'whatsapp',
    section: 'cart_reply',
  }),
  changeType: api.account.createPost({
    url: '/cartReply/changeType',
    schemas: CartReplyApi.changeType,
    scope: 'whatsapp',
    section: 'cart_reply',
  }),
  replaceFlow: api.account.createPost({
    url: '/cartReply/replaceFlow',
    schemas: CartReplyApi.replaceFlow,
    scope: 'whatsapp',
    section: 'cart_reply',
  }),
  removeFlow: api.account.createPost({
    url: '/cartReply/removeFlow',
    schemas: CartReplyApi.removeFlow,
    scope: 'whatsapp',
    section: 'cart_reply',
  }),
}
